import { lodash } from 'helpers';

import { LocalFileEntity } from '../../types';

export const parseAdditionalInformationFileIdsParam = (
  files: LocalFileEntity[] | undefined
) => lodash.compact(files?.map((v) => v.id));
